var map = {
	"./en/en-us.json": 792,
	"./en/newcornerstone-en.json": 2842,
	"./en/scientificConference-en.json": 2459,
	"./en/scientificExplorer-en.json": 8964,
	"./en/scientificSymposiaNav-en.json": 8321,
	"./en/square-forum-en.json": 9763,
	"./zh/newcornerstone-zh.json": 2962,
	"./zh/scientificConference-zh.json": 7779,
	"./zh/scientificExplorer-zh.json": 6268,
	"./zh/scientificSymposiaNav-zh.json": 3643,
	"./zh/square-forum-zh.json": 3151,
	"./zh/zh-cn.json": 4856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1852;